(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fanmoment-about-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fm-about-stories')) {
    customElements.define('fm-about-stories', class extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('slider-element');
        this.controls = this.querySelector('.fm-about-stories__controls');
        if (!this.slider || !this.controls) return;

        this.refresh = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateControls());
        };
        this.observer = new ResizeObserver(this.refresh);
        this.observer.observe(this.slider);
        const grid = this.slider.querySelector('.card-grid');
        if (grid) this.observer.observe(grid);
        this.refresh();
        customElements.whenDefined('slider-element').then(() => {
          if (this.isConnected) this.refresh();
        });
      }

      updateControls() {
        const styles = getComputedStyle(this.slider);
        const canScroll = /auto|scroll/.test(styles.overflowX)
          && this.slider.scrollWidth > this.slider.clientWidth + 1;
        this.controls.hidden = !canScroll;
        this.toggleAttribute('data-scrollable', canScroll);
        if (canScroll) {
          // Clear stale native hidden states when switching from desktop to mobile.
          this.controls.querySelectorAll('button').forEach(button => { button.hidden = false; });
          if (this.slider.initialized) this.slider.update();
        }
        if (this.slider.initialized) this.slider.updateTabindex();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
